<template>
  <div>
    <div class="pb-4">
      <div class="game">
        <div @click="selectGameAndRedirect" style="cursor: pointer">
          <div class="game-overlay"></div>
          <img
            v-if="gameDetails.GImage === null"
            src="../assets/images/default-thumbnail.png"
            class="w-100"
            alt=""
          />
          <img v-else :src="gameDetails.GImage" class="w-100" alt="" />
          <div class="game-category">{{ gameDetails.Category || "N/A" }}</div>
          <div class="game-details fadeIn-bottom">
            <h3 class="game-title">Download</h3>
            <p class="game-text"><i class="fa fa-eye"></i> 14</p>
          </div>
        </div>
        <!-- <a href="./games-details.html"> </a> -->
        <div class="d-flex justify-content-between pb-3 px-1">
          <div class="text-truncate font-weight-bold">
            {{ gameDetails.Gname }}
          </div>
          <div class="game-size">{{ gameDetails.Size || "N/A" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["gameDetails"],
  methods: {
    selectGameAndRedirect() {
      this.$store.dispatch("ADD_SELECTEDGAME", this.gameDetails);
      if (this.isSubscribed) {
        this.$router.push("/game-details/" + this.gameDetails.id);
        return;
      }

      this.$router.push("/subscribe");
    },
  },

  computed: {
    isSubscribed() {
      return this.$store.getters.GET_ISSUBSCRIBED;
    },
  },
};
</script>
